<template>
  <div class="user">
    <div class="header bg-color-red acea-row row-between-wrapper">
      <div class="picTxt acea-row row-between-wrapper">
        <div class="pictrue"><img :src="userInfo.avatar" /></div>
        <div class="text">
          <div class="acea-row row-middle">
            <div class="name line1" style="display: flex; align-items: center">
              <span>{{ userInfo.nickname }}</span>
              <!-- <img v-if="staff" style="width:20px;" :src="attendance?'https://img.ccloud8.cn/H5/%E6%AD%A3%E5%9C%A8%E5%87%BA%E5%8B%A4%402x.png':'https://img.ccloud8.cn/H5/%E6%9C%AA%E5%87%BA%E5%8B%A4%402x.png'" alt="" > -->
              <span v-if="staff" :class="attendance
                ? 'iconfont icon-kaoqinchuqin'
                : 'iconfont icon-weichuqin'
                "></span>
            </div>
            <div class="member acea-row row-middle" v-if="userInfo.vip">
              <img :src="userInfo.vip_icon" />{{ userInfo.vip_name }}
            </div>
          </div>
          <router-link :to="'/user/data'" class="id" v-if="userInfo.phone">
            ID：{{ userInfo.uid || 0
            }}<span class="iconfont icon-bianji1"></span>
          </router-link>
          <router-link :to="'/user/binding'" class="binding" v-else>
            <span>绑定手机号</span>
          </router-link>
        </div>
      </div>
      <span class="iconfont icon-shezhi" @click="$router.push({ path: '/user/data' })"></span>
    </div>
    <div class="wrapper">
      <div class="nav acea-row row-middle">
        <router-link :to="{ path: '/user/account' }" class="item">
          <div>我的余额</div>
          <div class="num">{{ userInfo.now_money || 0 }}</div>
        </router-link>
        <router-link :to="{ path: '/user/user_coupon' }" class="item">
          <div>我的班车月卡</div>
          <div class="num"> &nbsp;</div>
        </router-link>
      </div>
      <div class="myOrder">
        <div class="title acea-row row-between-wrapper">
          <div>我的订单</div>
          <router-link :to="'/order/list/'" class="allOrder">
            全部订单<span class="iconfont icon-jiantou"></span>
          </router-link>
        </div>
        <div class="orderState acea-row row-middle">
          <router-link :to="{ path: '/order/list/' + 0 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfk.png" />
              <span class="order-status-num" v-if="orderStatusNum.unpaid_count > 0">{{ orderStatusNum.unpaid_count
              }}</span>
            </div>
            <div>待付款</div>
          </router-link>
          <router-link :to="{ path: '/order/list/' + 3 }" class="item">
            <div class="pictrue">
              <img src="@assets/images/dfh.png" />
              <span class="order-status-num" v-if="orderStatusNum.evaluated_count > 0">{{ orderStatusNum.evaluated_count
              }}</span>
            </div>
            <div>已完成</div>
          </router-link>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">我的服务</div>
        <div class="serviceList acea-row row-middle">

          <template v-for="(item, index) in MyMenus">
            <div class="item" :key="index" @click="goPages(index)" v-if="item.wap_url &&
              item.is_property === false &&
              item.is_manager === false &&
              item.timecard === false
              ">
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="myService">
        <div class="title acea-row row-middle">充值服务</div>
        <div class="serviceList acea-row row-middle">
          <template v-for="(item, index) in MyMenus1">
            <div class="item" :key="index" @click="goPages1(index)" v-if="item.wap_url &&
              item.is_property === false &&
              item.is_manager === false &&
              item.timecard === false
              ">
              <div class="pictrue">
                <img :src="item.pic" />
              </div>
              <div>{{ item.name }}</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="footer-line-height"></div>
    <SwitchWindow v-on:changeswitch="changeswitch" :switchActive="switchActive" :login_type="userInfo.login_type">
    </SwitchWindow>
    <GeneralWindow :generalActive="generalActive" @closeGeneralWindow="closeGeneralWindow"
      :generalContent="generalContent"></GeneralWindow>
  </div>
</template>

<script>
import { getUser, getMenuUser, getisbancheApi } from "@api/user";
import { getStaffApi, outstatusApi, isManagerApi } from "@api/login";
import { wechatAuth } from "@api/public";
import { isWeixin } from "@utils";
import { oAuth, toAuth } from "@libs/wechat";
import { regularBusApi, isPubliCard } from "@api/login";
import SwitchWindow from "@components/SwitchWindow";
import GeneralWindow from "@components/GeneralWindow";
const NAME = "User";

export default {
  name: NAME,
  components: {
    SwitchWindow,
    GeneralWindow,
  },
  props: {},
  data: function () {
    return {
      department: 1,
      userInfo: {},
      MyMenus: [
        {
          pic: "https://img.ccloud8.cn/H5/%E6%88%91%E8%A6%81%E6%8A%A5%E4%BF%AE%402x.png",
          name: "报修/保洁",
          wap_url: "/repairs",
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: "https://img.ccloud8.cn/H5/%E6%88%91%E7%9A%84%E6%8A%A5%E4%BF%AE%402x.png",
          name: "我的报修",
          wap_url: "/record/0",
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: "https://img.ccloud8.cn/H5/%E6%88%91%E7%9A%84%E7%BB%B4%E4%BF%AE%402x.png",
          name: "我的维修",
          wap_url: "/maintain/0",
          is_property: true,
          is_manager: false,
          timecard: false,
        }, {
          pic: 'https://img.ccloud8.cn/H5/%E6%8A%A5%E4%BF%AE%E6%8E%A5%E5%8D%95%402x.png',
          name: '我的派单',
          wap_url: '/myrob',
          is_property: false,
          is_manager: false,
          timecard: true,
        },
        {
          pic: 'https://img.ccloud8.cn/H5/%E6%8A%A5%E4%BF%AE%E6%8E%A5%E5%8D%95%402x.png',
          name: '派单大厅',
          wap_url: '/rob',
          is_property: false,
          is_manager: false,
          timecard: true,
        },
        {
          pic: "https://img.ccloud8.cn/H5/%E6%94%AF%E4%BB%98%E7%A0%81.png",
          name: "支付码",
          wap_url: "/payYard",
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: "https://img.ccloud8.cn/H5/%E6%94%AF%E4%BB%98%E7%A0%81.png",
          name: "公卡",
          wap_url: "/Publicard",
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: 'https://img.ccloud8.cn/H5/%E8%99%9A%E6%8B%9F%E5%8D%A1%E5%85%85%E5%80%BC.png',
          name: '班车月卡',
          wap_url: '/category/' + 57,
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: 'https://img.ccloud8.cn/H5/%E8%99%9A%E6%8B%9F%E5%8D%A1%E5%85%85%E5%80%BC.png',
          name: '班车支付',
          wap_url: '/busPay?',
          is_property: true,
          is_manager: false,
          timecard: false,
        }
      ],
      MyMenus1: [
        {
          pic: "https://img.ccloud8.cn/H5/%E4%BD%99%E9%A2%9D%E5%85%85%E5%80%BC.png",
          name: "余额充值",
          wap_url: "/user/account",
          is_property: false,
          is_manager: false,
          timecard: false,
        },
        {
          pic: 'https://img.ccloud8.cn/H5/%E8%99%9A%E6%8B%9F%E5%8D%A1%E5%85%85%E5%80%BC.png',
          name: 'Ecasc充值',
          wap_url: '/category/' + 66,
          is_property: false,
          is_manager: false,
          timecard: false,
        },
      ],

      orderStatusNum: {},
      switchActive: false,
      isWeixin: false,
      generalActive: false,
      generalContent: {
        promoterNum: "",
        title: "",
      },
      staff: false,
      attendance: false,
      busNum: 0,
      isbancheDate: {}
    };
  },
  watch: {
    $route(n) {
      if (n.name === NAME) this.User();
    },
  },
  mounted: function () {
    this.User();
    this.isWeixin = isWeixin();
    // if (this.$store.getters.token) {
    isPubliCard().then((res) => {
      if (res.data.is_have_gongka != 1) {
        this.MyMenus.map(v => {
          if (v.name == '公卡') {
            v.is_manager = true;
          }
        })
      }
    })
    regularBusApi().then((res) => {
      this.busNum = res.data.length;
    });
    this.getStaff();
    this.getoutstatus();
    this.refresh();
    getisbancheApi().then((res) => {
      this.isbancheDate = res.data;
      this.MyMenus.map(v => {
        if (v.name == '班车支付') {
          if (res.data.is_banche == 1) {
            v.is_property = false;
            v.wap_url = v.wap_url + 'store_name=' + res.data.store_name
          }
        }
      })

    });

  },
  methods: {
    getoutstatus() {
      outstatusApi().then((res) => {
        if (res.data.out_status === 0) {
          this.attendance = false;
        } else {
          this.attendance = true;
        }
      });
    },
    getStaff() {
      //判断是不是物业人员
      getStaffApi().then((res) => {
        // 物业人员
        if (res.data.department == 1 || res.data.department == 2) {
          this.MyMenus.map(v => {
            if (v.name == '我的维修') {
              v.is_property = false;

            }
          })
          this.staff = true;
        }

        //res.data.department == 2 保洁
        this.department = res.data.department
        //res.data.manage===1是物业部门领导 ,展示 派单大厅
        if (res.data.manage == 1) {
          this.MyMenus.map(v => {
            if (v.name == '派单大厅') {
              v.timecard = false;
            }
            if (v.name == '我的派单') {
              v.timecard = false;
            }
          })
        }
      });
    },
    changeswitch: function (data) {
      this.switchActive = data;
    },
    User: function () {
      let that = this;
      getUser()
        .then((res) => {
          console.log(res)
          this.orderStatusNum = res.data.orderStatusNum;
          that.userInfo = res.data;
          this.generalContent = {
            promoterNum: `您在商城累计消费金额仅差 <span style="color: #ff8500;">${res.data.promoter_price || 0
              }元</span>即可开通推广权限`,
            title: "您未获得推广权限",
          };
        })
        .catch((err) => {
          // getAuth()
          oAuth();
        });
    },
    MenuUser: function () {
      let that = this;
      getMenuUser()
        .then((res) => {
          console.log(res.data.routine_my_menus);
          // that.MyMenus = res.data.routine_my_menus;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goPagey(url) {
      if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
        return this.$dialog.toast({ mes: "您还没有推广权限！！" });
      if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
        return (this.generalActive = true);
      }
      this.$router.push({ path: url });
    },
    refresh() {
      this.$forceUpdate();
    },
    goPages: function (index) {
      let url = this.MyMenus[index];

      if (url === "/user/user_promotion") {
        if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
          return this.$dialog.toast({ mes: "您还没有推广权限！！" });
        if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
          return (this.generalActive = true);
        }
      }
      if (url === "/customer/index" && !this.userInfo.adminid) {
        return this.$dialog.toast({ mes: "您还不是客服！！" });
      }
      if (this.MyMenus[index].wap_url == '/rob') {
        this.$router.push({ path: this.MyMenus[index].wap_url, query: { type: this.department } });
        return
      }
      this.$router.push({ path: this.MyMenus[index].wap_url });
    },
    goPages1: function (index) {
      let url = this.MyMenus1[index];
      if (url.name === "Ecasc充值") {
        location.href = "/category/66";
      } else {
        if (url === "/user/user_promotion") {
          if (!this.userInfo.is_promoter && this.userInfo.statu == 1)
            return this.$dialog.toast({ mes: "您还没有推广权限！！" });
          if (!this.userInfo.is_promoter && this.userInfo.statu == 2) {
            return (this.generalActive = true);
          }
        }
        if (url === "/customer/index" && !this.userInfo.adminid) {
          return this.$dialog.toast({ mes: "您还不是客服！！" });
        }
        this.$router.push({ path: this.MyMenus1[index].wap_url });
      }
    },
    closeGeneralWindow(msg) {
      this.generalActive = msg;
    },
  },
};
</script>

<style scoped>
.footer-line-height {
  height: 1rem;
}

.order-status-num {
  min-width: 0.33rem;
  background-color: #fff;
  color: #ee5a52;
  border-radius: 15px;
  position: absolute;
  right: -0.14rem;
  top: -0.15rem;
  font-size: 0.2rem;
  padding: 0 0.08rem;
  border: 0.02rem solid #ee5a52;
}

.pictrue {
  position: relative;
}

.switch-h5 {
  margin-left: 0.2rem;
}

.binding {
  padding: 0.05rem 0.2rem;
  background-color: #ca1f10;
  border-radius: 1rem;
  font-size: 0.14rem;
  border: 0.02rem solid #e8695e;
  color: #ffffff;
}
</style>
